import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageCard from '../components/ImageCard/ImageCard';
import places from '../static/places';
import useWindowPosition from '../hook/useWindowPosition';
import DividerWithText from '../components/Utils/Divider';
import { StyledTextSubTitle } from '../components/Utils/TextStyles';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    minHeight: '90vh',
    display: 'flex',
  },
  container: {
    textAlign: 'center',
  },
}));

export default function About() {
  const classes = useStyles();
  const checked = useWindowPosition('header');
  return (
    <div id='mesa-de-regalos'>
      <DividerWithText>B&U</DividerWithText>
      <div>
        <StyledTextSubTitle color={'#00774f'} style={{ textAlign: 'center' }}>
          Nuestro mejor regalo es su presencia en este día especial, pero si
          quieres obsequiarnos algo, aquí hay varias opciones:
        </StyledTextSubTitle>
      </div>
      <div
        className={classes.root}
        style={{
          justifyContent: 'center',
          display: 'flex',
          height: '90%',
          margin: 20,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left',
          backgroundSize: 'auto',
          backgroundImage: `url(${
            process.env.PUBLIC_URL + '/assets/ByU-10.png'
          })`,
        }}
      >
        <ImageCard place={places[2]} checked={checked} />
      </div>
    </div>
  );
}
